(function () {
  const root = document.querySelector('.bubbles-overlay');
  if (!root) return;
  const BUBBLE_COUNT = 24; // tweak
  for (let i = 0; i < BUBBLE_COUNT; i++) {
    const b = document.createElement('span');
    b.className = 'bubble';
    // random size, position, speed, drift
    const size = Math.floor(Math.random() * 18) + 8; // 8–26px
    const left = Math.random() * 100;                // %
    const delay = Math.random() * 8;                 // s
    const dur = Math.random() * 8 + 10;             // 10–18s
    const drift = (Math.random() * 40 - 20) + 'px'; // -20 to 20px
    const scale = 0.9 + Math.random() * 0.5;        // 0.9–1.4

    b.style.width = size + 'px';
    b.style.height = size + 'px';
    b.style.left = left + '%';
    b.style.animationDelay = delay + 's';
    b.style.setProperty('--dur', dur + 's');
    b.style.setProperty('--drift', drift);
    b.style.setProperty('--scale', scale);

    // optional subtle color/shine
    b.style.background = 'radial-gradient(circle at 30% 30%, rgba(255,255,255,0.65), rgba(255,255,255,0.15) 60%, rgba(255,255,255,0))';
    root.appendChild(b);
  }
})();